
import axios from "axios"
import router from '../../router';
import { func } from '../../main';


const state = {
    MeetingList: [],
};


const getters = {
    GetMeetingList2(state: any) {
        return state.MeetingList;
    },
};

const mutations = {
    SetMeetingList(state: any, list: any) {
        state.MeetingList = list;
    },
};

const actions = {
    GetMeetingListFromServer(context: any, filter: any) {
        context.commit("SetLoading", true);
        axios.get("Task/GetMeetingList", {
            params: {
                personId: filter.personId
            }
        })
        
            .then(data => {
                context.commit("SetLoading", false);
                if (data.data.length > 0) {
                    context.commit("SetMeetingList", data.data);
                    return;
                }
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
